import { COLORS } from '@wehunt/ui'
import { useT } from '../i18n/useT'

const buttonStyle = { marginTop: 16, padding: '8px 16px', borderRadius: 6, cursor: 'pointer' } as const

export function QueryError({
  error,
  onRetry,
  secondaryAction,
}: {
  error: unknown
  onRetry?: () => void
  /** A second way out, shown beside Retry when retrying alone may not help. */
  secondaryAction?: { label: string; onClick: () => void }
}) {
  const { t } = useT('common')
  const message = error instanceof Error ? error.message : String(error)
  return (
    <div style={{ padding: 24 }}>
      <h2 style={{ color: COLORS.error, margin: 0 }}>{t('states.error')}</h2>
      <p style={{ color: COLORS.onSurfaceVariant, marginTop: 8 }}>{t('states.errorDetail')}</p>
      <details style={{ marginTop: 12, color: COLORS.outline }}><summary>{t('states.errorDetails')}</summary><pre>{message}</pre></details>
      {onRetry && (
        <button onClick={onRetry} style={{ ...buttonStyle, background: COLORS.primary, color: COLORS.onPrimary, border: 'none' }}>
          {t('buttons.retry')}
        </button>
      )}
      {secondaryAction && (
        <button
          type="button"
          onClick={secondaryAction.onClick}
          style={{ ...buttonStyle, marginLeft: onRetry ? 8 : 0, background: 'transparent', color: COLORS.primary, border: `1px solid ${COLORS.primary}` }}
        >
          {secondaryAction.label}
        </button>
      )}
    </div>
  )
}
